import { queryClient, queryKeys } from '@queryClient';
import type { LibStorage } from '@types';
import { noSpaceWarning } from './showWarningModals';

export async function baseSpaceCheck() {
  const {
    usedStorage = 0,
    levelStorage = 0,
    shoppingStorage = 0,
  } = queryClient.getQueryData<LibStorage>(queryKeys.libSpace) ?? {};
  const remainStorage = levelStorage + shoppingStorage - usedStorage;
  if (remainStorage <= 0) await noSpaceWarning();
  // 去掉空间容量<100MB的提示
  // if (remainStorage < SPACE_WARNING_SIZE) await spaceWarning();
}

export async function remainSpaceCheck(size: number) {
  const {
    usedStorage = 0,
    levelStorage = 0,
    shoppingStorage = 0,
  } = queryClient.getQueryData<LibStorage>(queryKeys.libSpace) ?? {};
  const remainStorage = levelStorage + shoppingStorage - usedStorage;
  if (size > remainStorage) await noSpaceWarning();
}
